import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../../Components/layouts";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LazyCardMedia from 'Components/LazyCardMedia';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import AppLoader from '../../../Components/AppLoader';
import axios from 'axios';
import aiImg from '../../../Assets/images/ai.png';
import dtmmImg from '../../../Assets/images/assesment.png';

const ApiUrl = global.platformURI;

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        height: 180,
        background: '#FFFFFF',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
    },
    cover: {
        width: 174,
        height: 132,
        paddingTop: 17,
        marginTop: 25,
        marginLeft: 20,
        borderRadius: 5,
        maxWidth: '20%',
    },
    content: {
        flex: '1 0 auto',
        maxWidth: '80%',
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '800px',
    },
}));

const Assessments = () => {
    const classes = useStyles();
    const [assessments, setAssessments] = useState([]);
    const [iframeUrl, setIframeUrl] = useState('');
    const [isIframeVisible, setIsIframeVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showInstructions, setShowInstructions] = useState(false);
    const [selectedAssessment, setSelectedAssessment] = useState(null);

    useEffect(() => {
        fetchAssessments();
    }, []);

    const fetchAssessments = async () => {
        try {
            const res = await axios.get(`${ApiUrl}main/api/user-assigned-assessments/`);
            const filteredAssessments = res.data?.data?.filter(
                item => item?.assessment_license_id?.assessment_id?.name === "Digital Talent Maturity Model" ||"AI Maturity Model"
            );
            setAssessments(filteredAssessments || []);
        } catch (error) {
            console.error("Error fetching assessments:", error);
        } finally {
            setLoading(false);
        }
    };

    const launchAssessment = async (name) => {
        try {
            setLoading(true);
            if(name=== "AI Maturity Model"){
                const res = await axios.get(`${ApiUrl}main/airdaurl`);
                const url = res.data?.data?.rdaurl;
                if (url) {
                    setIframeUrl(url);
                    setIsIframeVisible(true);
                    setShowInstructions(false);
                }
                return;
            }
            const res = await axios.get(`${ApiUrl}main/rdaurl`);
            const url = res.data?.data?.rdaurl;
            if (url) {
                setIframeUrl(url);
                setIsIframeVisible(true);
                setShowInstructions(false);
            }
        } catch (error) {
            console.error("Error launching assessment:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleLaunchClick = (assessment) => {
        setSelectedAssessment(assessment);
        setShowInstructions(true);
    };


    const handleTutorialLaunch = (name) => {
        if(name === "AI Maturity Model"){
            window.open("https://userguides-company.s3.af-south-1.amazonaws.com/assessments/User+Guide+-+AIR.pdf", "_blank");
        }
        else{
        window.open("https://userguides-company.s3.af-south-1.amazonaws.com/assessments/DTMM_userguide_v1.pdf", "_blank");
        }

      };

    return (
        <Layout>
            <main>
                {loading ? (
                    <AppLoader minHeight={800} />
                ) : isIframeVisible ? (
                    <div style={{ marginTop: 20, position: 'relative' }}>
                        {loading && <AppLoader overlay />}
                        <iframe
                            src={iframeUrl}
                            width="100%"
                            height="800px"
                            frameBorder="0"
                            title="Assessment"
                            onLoad={() => setLoading(false)}
                            style={{ display: loading ? 'none' : 'block' }}
                        ></iframe>
                    </div>
                ) : showInstructions ? (
    <Card
  variant="outlined"
  style={{ padding: 40, margin: "40px auto" }}
>
  <Typography
    variant="h5"
    align="center"
    gutterBottom
    style={{ fontWeight: 600, color: "#483b88" }}
  >
    <b>INSTRUCTIONS</b>
  </Typography>
  <ul style={{ lineHeight: 1.8, paddingLeft: 20, color: "#483b88" }}>
    <li>
      The {selectedAssessment?.assessment_license_id?.assessment_id?.name} facilitates a holistic approach for your
      organization’s digital transformation strategy through a systematic process that
      encompasses talent and cultural aspects.
    </li>
    <li>
      Your responses will be aggregated with the responses of your colleagues who are also
      completing the same assessment.
    </li>
    <li>
      This assessment is based on the TM Forum {selectedAssessment?.assessment_license_id?.assessment_id?.name} and Deviare is an
      authorised and licensed partner of the TM Forum.
    </li>
    <li>
      Please ensure that you make your selections based on <b>BOTH</b> the status quo (current
      state) and aspiration (future state).
    </li>
    <li>Your responses are automatically saved when you click on the ‘Next’ button.</li>
    <li>A summary of your responses will always be available to you under the ‘Reports’ section.</li>
    <li>
      Your assessment will take approximately <b>120</b> minutes to complete. You may pause and
      resume the assessment at any time.
    </li>
    <li>Launch the tutorial guide to complete the assessment.</li>
  </ul>

  <div style={{ display: "flex", justifyContent: "center", gap: 20, marginTop: 30 }}>
  <Button
  onClick={() => launchAssessment(selectedAssessment?.assessment_license_id?.assessment_id?.name)}
  variant="contained"
  color="primary"
  style={{ padding: "10px 30px", fontSize: 14, borderRadius: 5 }}
>
  Start Assessment
</Button>
    <Button
      onClick={() => handleTutorialLaunch(selectedAssessment?.assessment_license_id?.assessment_id?.name)}
      variant="contained"
      color="primary"
      style={{ padding: "10px 30px", fontSize: 14, borderRadius: 5 }}
    >
      Launch Tutorial
    </Button>
  </div>
</Card>

                ) : (
                    <>
                        <h2>My Assessments</h2>
                        {/* <Typography variant="subtitle1">{AssesmentsSummary}</Typography> */}
                        <Grid container spacing={2} style={{ marginTop: 10 }}>
                            {assessments.length > 0 ? (
                                assessments.map((assessment, index) => (
                                    <Grid item xs={6} key={index}>
                                        <Card className={classes.root}>
                                        <LazyCardMedia
    className={classes.cover}
    image={
        assessment?.assessment_license_id?.assessment_id?.name === 'AI Maturity Model'
            ? aiImg
            : dtmmImg
    }
    title={assessment?.assessment_license_id?.assessment_id?.name}
/>
                                            <CardContent className={classes.content}>
                                                <Typography variant="h1" color="primary">
                                                    {assessment?.assessment_license_id?.assessment_id?.name}
                                                </Typography>
                                                <Button
                                                    onClick={() => handleLaunchClick(assessment)}
                                                    style={{
                                                        fontSize: 12,
                                                        borderRadius: 5,
                                                        padding: '12px 55px',
                                                        marginTop: 20,
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Launch
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))
                            ) : (
                                <Typography variant="h6" color="textSecondary">
                                    No available assessments.
                                </Typography>
                            )}
                        </Grid>
                    </>
                )}
            </main>
        </Layout>
    );
};

export default Assessments;
